import { useCallback } from "react";

import actions from "actions";
import api from "api";
import { useAppDispatch } from "store";

export const useUserReload = (): ((
  success?: () => void,
  fail?: () => void,
) => void) => {
  const dispatch = useAppDispatch();
  const reloadUser = useCallback(
    (success?: () => void, fail?: () => void) => {
      api.users.me(
        "",
        (me) => {
          api.setQueryData(api.users.me, [], me);
          dispatch(actions.user.receiveUser(me));
          success?.();
        },
        () => {
          fail?.();
        },
      );
    },
    [dispatch],
  );

  return reloadUser;
};
